import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const FemaleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 36 36">
      <path
        d="M15.375 31.6875V24.375H12.75C12.3 24.375 11.9375 24.1875 11.6625 23.8125C11.4125 23.4375 11.3625 23.0375 11.5125 22.6125L15.075 12.45C15.3 11.825 15.675 11.35 16.2 11.025C16.75 10.675 17.35 10.5 18 10.5C18.65 10.5 19.2375 10.675 19.7625 11.025C20.3125 11.35 20.7 11.825 20.925 12.45L24.4875 22.6125C24.6625 23.0375 24.6125 23.4375 24.3375 23.8125C24.0625 24.1875 23.7 24.375 23.25 24.375H20.625V31.6875C20.625 32.0625 20.5 32.375 20.25 32.625C20 32.875 19.6875 33 19.3125 33H16.6875C16.3125 33 16 32.875 15.75 32.625C15.5 32.375 15.375 32.0625 15.375 31.6875ZM18 8.7375C17.225 8.7375 16.55 8.4625 15.975 7.9125C15.425 7.3375 15.15 6.6625 15.15 5.8875C15.15 5.0875 15.425 4.4125 15.975 3.8625C16.525 3.2875 17.2 3 18 3C18.8 3 19.475 3.2875 20.025 3.8625C20.6 4.4125 20.8875 5.075 20.8875 5.85C20.8875 6.65 20.6 7.3375 20.025 7.9125C19.475 8.4625 18.8 8.7375 18 8.7375Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
